import { useEffect, useState } from "react";
import { SideBar } from "./inc/sideBar";
import { TopHeader } from "./inc/topHeader";
import { getTotalStudentCount } from "../../services/StudentService";
import { getTotalStudyCount } from "../../services/StudyService";
import { getTotalProgressCount } from "../../services/ProgressService";
import { getTotalCommentCount } from "../../services/commentService";
import ProgressChart from "./progressChart";
import ProgressBar from "./progressBar";

const CoordinatorHome = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const [studentCount, setStudentCount] = useState(0);
  const [studyCount, setStudyCount] = useState(0);
  const [progressCount, setProgressCount] = useState(0);
  const [commentCount, setCommentCount] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setSidebarOpen(false);
    }
  }, [windowWidth]);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const totalStudents = 200;
  const totalStudies = 150;
  const totalProgress = 250;
  const totalComments = 270;

  useEffect(() => {
    const fetchCounts = async () => {

      try {
        const studentResponse = await getTotalStudentCount();
        setStudentCount(studentResponse.data?.data);

        const studyResponse = await getTotalStudyCount();
        setStudyCount(studyResponse.data?.total);

        const progressResponse = await getTotalProgressCount();
        setProgressCount(progressResponse.data?.data);

        const commentResponse = await getTotalCommentCount();
        setCommentCount(commentResponse.data?.total);
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    fetchCounts();
  }, []);

  const calculateProgress = (count, total) => {
    return Math.min(Math.round((count / total) * 100), 100);
  };

  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="d-flex position-relative" style={{ minHeight: "100vh" }}>
        <SideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          activeMenu={activeMenu}
          toggleMenu={toggleMenu}
          windowWidth={windowWidth}
        />
        <div className="main-panel">
          <TopHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            windowWidth={windowWidth}
          />

          <div className="container mt-0">
            <div className="page-inner">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-xl-3">
                  <div className="card zis-shadow rounded-2">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h5 className="fw-bold">Total Students</h5>
                          <p className="text-muted">All students</p>
                        </div>
                        <h3 className="text-warning fw-bold fs-1">
                          {studentCount}
                        </h3>
                      </div>
                      <div className="progress progress-sm">
                        <div
                          className="progress-bar bg-warning"
                          role="progressbar"
                          style={{
                            width: `${calculateProgress(
                              studentCount,
                              totalStudents
                            )}%`,
                          }}
                          aria-valuenow={calculateProgress(
                            studentCount,
                            totalStudents
                          )}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <p className="text-muted mb-0">Number of students</p>
                        <p className="text-muted mb-0">
                          {calculateProgress(studentCount, totalStudents)}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-xl-3">
                  <div className="card zis-shadow rounded-2">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h5>
                            <b>Total Study</b>
                          </h5>
                          <p className="text-muted">All studies</p>
                        </div>
                        <h3 className="text-primary fw-bold fs-1">
                          {studyCount}
                        </h3>
                      </div>
                      <div className="progress progress-sm">
                        <div
                          className="progress-bar bg-primary"
                          role="progressbar"
                          style={{
                            width: `${calculateProgress(
                              studyCount,
                              totalStudies
                            )}%`,
                          }}
                          aria-valuenow={calculateProgress(
                            studyCount,
                            totalStudies
                          )}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <p className="text-muted mb-0">Number of studies</p>
                        <p className="text-muted mb-0">
                          {calculateProgress(studyCount, totalStudies)}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-xl-3">
                  <div className="card zis-shadow rounded-2">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h5>
                            <b>Total Progress</b>
                          </h5>
                          <p className="text-muted">All progress</p>
                        </div>
                        <h3 className="text-danger fw-bold fs-1">
                          {progressCount}
                        </h3>
                      </div>
                      <div className="progress progress-sm">
                        <div
                          className="progress-bar bg-danger"
                          role="progressbar"
                          style={{
                            width: `${calculateProgress(
                              progressCount,
                              totalProgress
                            )}%`,
                          }}
                          aria-valuenow={calculateProgress(
                            progressCount,
                            totalProgress
                          )}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <p className="text-muted mb-0">Number of progress</p>
                        <p className="text-muted mb-0">
                          {calculateProgress(progressCount, totalProgress)}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-xl-3">
                  <div className="card zis-shadow rounded-2">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h5>
                            <b>Total Comment</b>
                          </h5>
                          <p className="text-muted">All comments</p>
                        </div>
                        <h3 className="text-success fw-bold fs-1">
                          {commentCount}
                        </h3>
                      </div>
                      <div className="progress progress-sm">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{
                            width: `${calculateProgress(
                              commentCount,
                              totalComments
                            )}%`,
                          }}
                          aria-valuenow={calculateProgress(
                            commentCount,
                            totalComments
                          )}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <p className="text-muted mb-0">Number of comments</p>
                        <p className="text-muted mb-0">
                          {calculateProgress(commentCount, totalComments)}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-xl-4">
                  <div className="card zis-shadow rounded-1">
                    <div className="card-header">
                      <h5 className="fw-bold">Overall Progress</h5>
                    </div>
                    <div className="card-body">
                      <ProgressChart />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-xl-8">
                  <div className="card zis-shadow rounded-1">
                    <div className="card-header">
                      <h5 className="fw-bold">Month Study Progress</h5>
                    </div>
                    <div className="card-body">
                      <ProgressBar />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoordinatorHome;
